import store from '../../../core/store';

export const listCompanySegments = () => {
  return store.dispatch({
    action: 'table.company_segments/LIST_COMPANY_SEGMENTS',
    method: 'GET',
    endpoint: '/company_segments',
    main: true,
  });
};

export const createCompanySegment = (formData) => {
  return store.dispatch({
    action: 'table.company_segments/CREATE_COMPANY_SEGMENTS',
    method: 'POST',
    endpoint: '/company_segments',
    data: formData,
  });
};

export const readCompanySegment = (company_segment_id) => {
  return store.dispatch({
    action: 'table.company_segments/READ_COMPANY_SEGMENT',
    method: 'GET',
    endpoint: '/company_segments/' + company_segment_id,
  });
};

export const updateCompanySegment = (company_segment_id, formData) => {
  return store.dispatch({
    action: 'table.company_segments/UPDATE_COMPANY_SEGMENT',
    method: 'PUT',
    endpoint: '/company_segments/' + company_segment_id,
    data: formData,
  });
};

export const deleteCompanySegment = (id) => {
  return store.dispatch({
    action: 'table.company_segments/DELETE_COMPANY_SEGMENTS',
    method: 'DELETE',
    endpoint: '/company_segments/' + id,
  });
};
